
export default {
    name: 'Versao',
    components: {},
    setup() {
        const version = process.env.PACKAGE_VERSION;
        return {
            version,
        };

    },
}
